// extracted by mini-css-extract-plugin
module.exports = {"container":"InfoPanel_container__1jSyE"};